<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16">门店退款</div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row">
              <el-select v-model="query.auditStatus" placeholder="请选择">
                <el-option
                  v-for="item in typeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <v-date @time="changeDate" class="ml10 mr10"></v-date>
              <el-button type="primary" @click="doData">搜索</el-button>
            </div>
          </div>
          <div class="plr16" v-perm="{key:'shopRefund', value:'shopRefund:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="refundTypeCn" label="退款分类" width="auto">
                <template slot-scope="scope">{{ scope.row.refundTypeCn }}退款</template>
              </el-table-column>
              <el-table-column prop="refundAmount" label="退款金额" width="auto"></el-table-column>
              <el-table-column prop="refundBaseAmount" label="退款本金" width="auto"></el-table-column>
              <el-table-column prop="refundGiveAmount" label="退款赠金" width="auto"></el-table-column>
              <el-table-column prop="staffIdCn" label="服务技师" width="auto"></el-table-column>
              <el-table-column prop="deductAmount" label="扣除提成金额" width="110"></el-table-column>
              <el-table-column label="申请时间" width="160">
                <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
              </el-table-column>
              <el-table-column label="审核状态" width="auto" prop="auditStatusCn"></el-table-column>
              <el-table-column label="退款备注" width="auto" prop="remark"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <div v-if="!scope.row.tatalsShow">
                    <el-link type="primary" @click="addClick(scope.row)">详情</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import member from "../../components/member";
import editSet from "./edit";
export default {
  data() {
    return {
      url: this.$url.companyRefund.list,
      list: [],
      activeName: "first",
      query: {
        size: 20,
        start: 1,
        beginTime: new Date(),
        endTime: new Date(),
        auditStatus: ''
        // orderStatus: "finish",
        // memberId: ""
      },
      typeOption: [
         {
          value: '',
          label: '全部类型'
        },
        {
          value: 'wait',
          label: '待审核'
        },
        {
          value: 'pass',
          label: '审核通过'
        },
        {
          value: 'refuse',
          label: '审核不通过'
        }
      ],
      height: this.$store.getters.MainHeight,
    };
  },
  mixins: [minxin],
  components: {
    member,
    editSet // detailSet
  },
  computed: {},

  created() {
    this.totalCounts();
  },

  methods: {
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    back() {
      this.$router.push("/collectMoney");
      // this.$router.go(-1);
    },
    addClick(row) {
      this.$refs["editSetForm"].$emit("set", row);
    },
    totalCounts () {
      this.$api.post(this.$url.companyRefund.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    handleChange(bool) {
      if (bool) {
        this.getData();
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  background: #fff;
  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
  }
}
</style>

